import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { baseHeaders } from 'util/axios-request';
import { addStaffRegular, editStaffRegular, cancelStaffRegular } from '@/api/org/per';
import Upload from '_c/upload';
import StaffSearch from '_c/staff-search';
import { getRegularEnv } from 'api/dashboard';
var baseURL = process.env.VUE_APP_BASE_API;
var dataForm = function dataForm() {
  return {
    probation_day: '',
    evaluate_state: '1',
    formal_date: '',
    remark: '',
    // 备注
    attachment: []
  };
};
export default {
  components: {
    Upload: Upload,
    StaffSearch: StaffSearch
  },
  props: {
    sysInfoArr: {
      type: Object,
      default: function _default() {
        return {
          state: [] // 在职状态
        };
      }
    }
  },
  data: function data() {
    var slef = this;
    return {
      visible: false,
      disabled: false,
      operateType: '',
      dataForm: dataForm(),
      limit: 5,
      fileFormat: ['.png', '.jpg', '.jpeg', '.xls', '.xlsx', '.doc', '.docx', '.pdf'],
      uploadUrl: baseURL + '/web/tool/upload_file',
      baseHeaders: baseHeaders(),
      initFiles: [],
      dataRule: {
        hire_date: [{
          required: true,
          message: this.$t('795')
        }],
        formal_date: [{
          required: true,
          message: this.$t('800')
        }],
        evaluate_state: [{
          required: true,
          message: this.$t('800')
        }]
      },
      evaluateDisabled: [],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          // 离职日期在hire_date之后可以选择
          var hire_date = new Date(slef.dataForm.hire_date).getTime() - 86400000;
          return time.getTime() < hire_date;
        }
      }
    };
  },
  computed: {
    isCreate: function isCreate() {
      return this.operateType === 'create';
    },
    isSelected: function isSelected() {
      if (this.operateType !== 'create') return true;
      if (!this.dataForm.staff_name) return false;
      return true;
    },
    title: function title() {
      var titles = {
        handle: this.$t('invite_49'),
        edit: this.$t('invite_50'),
        create: this.$t('i18n.1647916135444')
      };
      return titles[this.operateType];
    }
  },
  methods: {
    init: function init(item, type) {
      var _this = this;
      this.visible = true;
      this.operateType = type;
      this.dataForm = item ? JSON.parse(JSON.stringify(Object.assign(this.dataForm, item))) : dataForm();
      var evaluateKey = Object.keys(this.sysInfoArr.staff_evaluate_state);
      this.evaluateDisabled = [];
      // “评估通过”或“评估不通过”可改为“评估不通过”或“评估通过”，不可改为“待评估”
      evaluateKey.forEach(function (key) {
        _this.evaluateDisabled.push(key === '1' && ['2', '3'].includes(_this.dataForm.evaluate_state));
      });
      this.$nextTick(function () {
        if (!_this.$refs.upload) return;
        _this.$refs.upload.successFileList = _this.dataForm.attachment;
      });
    },
    disabledDate: function disabledDate(t) {
      // 离职日期在hire_date之后可以选择
      return new Date().getTime() < t.getTime();
    },
    onProbationDay: function onProbationDay(v) {
      // 填写了“试用期(天)”，自动计算：转正日期=入职日期+试用期(天)——入职日期为第0天
      if (!String(v)) return;
      var day = Number(v);
      var hireData = new Date(this.dataForm.hire_date);
      hireData.setDate(hireData.getDate() + day);
      this.dataForm.formal_date = this.formatDay(hireData);
    },
    // 时间戳转换为日期 2020-09-08
    formatDay: function formatDay(timestamp) {
      var date = new Date(timestamp);
      var YY = date.getFullYear();
      var MM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return "".concat(YY, "-").concat(MM, "-").concat(DD);
    },
    uploadSuccess: function uploadSuccess(val) {
      this.dataForm.attachment = val || [];
    },
    onCancel: function onCancel() {
      var _this2 = this;
      // 撤销转正
      this.$alert("<p> ".concat(this.$t('invite_52'), " </p><p> ").concat(this.$t('invite_53'), " </p>"), this.$t('invite_51'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        dangerouslyUseHTMLString: true
      }).then(function () {
        cancelStaffRegular({
          staff_id: _this2.dataForm.staff_id
        }).then(function (res) {
          if (res && res.code === 1) {
            _this2.visible = false;
            _this2.$message.success(res.message);
            _this2.$emit('refreshTableList');
          }
        });
      }).catch(function () {});
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;
      if (!this.isSelected) {
        this.$message.error(this.$t('i18n.1647917583450'));
        return;
      }
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          _this3.disabled = true;
          var query = {
            staff_id: _this3.dataForm.staff_id,
            remark: _this3.dataForm.remark,
            probation_day: _this3.dataForm.probation_day,
            formal_date: _this3.dataForm.formal_date,
            attachment: _this3.dataForm.attachment.length ? _this3.dataForm.attachment : [{
              file_name: '',
              object_key: '',
              object_url: ''
            }]
          };
          if (['handle', 'create'].includes(_this3.operateType)) query.state = _this3.dataForm.evaluate_state;
          _this3.ajaxFn(query).then(function (res) {
            if (res && res.code === 1) {
              _this3.visible = false;
              _this3.$message.success(res.message);
              _this3.$emit('refreshTableList');
            }
          }).catch(function () {}).finally(function () {
            return _this3.disabled = false;
          });
        }
      });
    },
    ajaxFn: function ajaxFn(data) {
      return this.operateType === 'edit' ? editStaffRegular(data) : addStaffRegular(data);
    },
    handleStaffChange: function handleStaffChange(v) {
      var _this4 = this;
      this.dataForm = dataForm();
      if (!v.staff_id) return;
      this.$http({
        url: '/web/staff/view',
        data: {
          staff_id: v.staff_id
        }
      }).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          var _res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this4.dataForm = JSON.parse(JSON.stringify(Object.assign(_this4.dataForm, res.data)));
                _this4.dataForm.state_txt = _this4.dataForm.state_name;
                if (!(!_this4.dataForm.probation_day || _this4.dataForm.probation_day === '0')) {
                  _context.next = 7;
                  break;
                }
                _context.next = 5;
                return getRegularEnv({
                  code: 'STAFF_PROBATION_DAY'
                });
              case 5:
                _res = _context.sent;
                if (_res && _res.code) {
                  _this4.dataForm.probation_day = _res.data;
                }
              case 7:
                if (!_this4.dataForm.formal_date) {
                  _this4.onProbationDay(_this4.dataForm.probation_day);
                }
                if (!_this4.dataForm.formal_state_txt) {
                  _this4.update_period_status(_this4.dataForm.evaluate_state);
                }
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 根据转正日期、试用期评估联动更新状态
    update_period_status: function update_period_status(value) {
      var v = +value;
      var statusMap = new Map([[1, this.$t('invite_30')], [2, this.$t('invite_31')], [3, this.$t('invite_32')]]);
      if (v === 2) {
        if (!this.dataForm.formal_date) {
          this.dataForm.formal_state_txt = '';
          return;
        }
        var formal_date = parseInt(this.dataForm.formal_date.replace(/-/g, ''));
        var nowDate = parseInt(this.$util.fmtDate('yyyy-MM-dd').replace(/-/g, ''));
        if (formal_date > nowDate) {
          this.dataForm.formal_state_txt = statusMap.get(1);
        } else {
          this.dataForm.formal_state_txt = statusMap.get(2);
        }
      } else {
        this.dataForm.formal_state_txt = statusMap.get(v);
      }
    },
    handleDatePickerChange: function handleDatePickerChange() {
      if (+this.dataForm.evaluate_state === 2) {
        this.update_period_status(this.dataForm.evaluate_state);
      }
    }
  }
};